import { UseFormRegister, FieldErrors } from "react-hook-form";
import { Input } from "@/components/ui/input";
import { Label } from "@/components/ui/label";
import { EventFormData } from "./types";

interface EventBasicInfoProps {
  register: UseFormRegister<EventFormData>;
  errors: FieldErrors<EventFormData>;
}

const EventBasicInfo = ({ register, errors }: EventBasicInfoProps) => {
  return (
    <div className="grid grid-cols-2 gap-6">
      <div className="space-y-2">
        <Label htmlFor="title">Event Title</Label>
        <Input
          id="title"
          {...register("title", { required: true })}
          className={errors.title ? "border-red-500" : ""}
        />
      </div>

      <div className="space-y-2">
        <Label htmlFor="venue">Venue</Label>
        <Input
          id="venue"
          {...register("venue", { required: true })}
          className={errors.venue ? "border-red-500" : ""}
        />
      </div>
    </div>
  );
};

export default EventBasicInfo;